import styled from "@emotion/styled";
import tw from "tailwind.macro";

export const CookieConsentDiv = styled.div`
    ${tw`absolute`};
`;

export const Root = styled.div``;
